import { Text } from "@clipboard-health/ui-components";

import { type PaymentsListItem } from "../types/PaymentsListItem";

export interface PaymentsListItemTitleProps {
  item: PaymentsListItem;
  compact?: boolean;
}

export function PaymentsListItemTitle(props: PaymentsListItemTitleProps) {
  const { compact = true, item } = props;

  return (
    <Text
      semibold
      variant={compact ? "body1" : "h5"}
      sx={(theme) => ({ color: theme.palette.text[compact ? "primary" : "secondary"] })}
    >
      {getTitleText(item)}
    </Text>
  );
}

function getTitleText(item: PaymentsListItem): string {
  if (item.workplace) {
    return item.workplace.attributes.name;
  }

  if (
    item.attributes.paymentCategory === "manual-bonus" ||
    item.attributes.paymentCategory === "etp-bonus"
  ) {
    return "Bonus";
  }

  return "Unknown";
}
